module.exports = __webpack_public_path__ + "static/turtle-creek-house02-a0b8ac097d69ddd4de1d31688deea18c.jpg";